<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<style lang="scss" scoped>
.event-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.popup-example {
  .vs-input {
    float: left;
    width: 50%;
    margin: 10px;
    margin-top: 5px;
  }
  .con-select {
    margin-left: 10px;
    width: 50%;
    margin-bottom: 10px;
  }
}
.profile-edit {
    display: inherit !important;
}
</style>
<template>
  <div id="demo-basic-card">
    <div class="event-list-header event-list-header ml-0">
      <h3 v-if="!showNoMappedEventMsg">All Events</h3>
      <span v-if="UserRole == 2">
        <vs-button @click="addEvent" :disabled="disableAddEventBtn">
          <feather-icon class="mr-2 ml-0" icon="PlusIcon" />
          Create New Event</vs-button
        >
        <div class="event-list-view ml-3">
          <ul class="grid-ul">
            <li
              id="listview"
              class="grid-li active"
              @click="switchEventView('grid')"
            >
              <feather-icon class="iconsize" icon="ListIcon" />
            </li>
            <li id="gridview" class="grid-li" @click="switchEventView('list')">
              <feather-icon class="iconsize" icon="GridIcon" />
            </li>
          </ul>
        </div>
        <!-- *** Menu Add Button Dont Remove *** -->
        <!-- <vs-button type="gradient" @click="addMenu">Add Menu</vs-button> -->
      </span>
    </div>
    <!--<div class="vx-card p-6 blank-attendee">
      <div class="entity-create-sec">
          <div class="emtity-icon">
            <feather-icon class="" icon="GridIcon" />
          </div>
          <div class="entity-create-desc">
            <h2>No events setup yet</h2>
            <p>Setup your event here</p>
            <div class="entity-setup-buttons">
              <vs-button color="primary" type="filled">MANAGE EVENT</vs-button>
              <vs-button color="primary" type="filled" class="new-entity-add-button ">CREATE NEW EVENT</vs-button>
            </div>
          </div>
      </div>
    </div>-->
    <event-admin-add
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="eventadmindata"
    />
    <div class="vx-row">
      <!-- USER PRODFILE CARD -->

      <!-- <div v-else> -->
      <div
        v-if="showNoMappedEventMsg"
        class="vx-col w-full"
        style="text-align: center; margin-top: 19%"
      >
        <h3>
          You are not mapped to manage any events!<br />
          Please contact Organizer
        </h3>
      </div>
      <div
        v-for="singleEvent in eventListData"
        v-bind:key="singleEvent.EventId"
        :class="
          switchView == true
            ? 'vx-col w-full lg:w-1/3 sm:w-1/2 mb-base'
            : 'vx-col w-full lg:w-1/1 sm:w-1/1 mb-base all-event-list'
        "
      >
        <vx-card
          class="p-1 single-event-wrap switchview"
          style="height: 100%"
          v-if="switchView"
        >
          <div class="text-center">
            <h4>{{ singleEvent.EventFullName }}</h4>
            <!--<a href="#">Clone</a>-->
            <!--<h4>Global Expo 2020</h4>-->
            <p class="text-grey date">
              {{ singleEvent.EventStartDateStr }} -
              {{ singleEvent.EventEndDateStr }} {{ singleEvent.TimeZone }}
            </p>
            <div class="event-clone-drop">
              <vs-dropdown vs-custom-content vs-trigger-click>
                <a class="" href.prevent>
                  <span></span>
                  <span></span>
                  <span></span>
                </a>

                <vs-dropdown-menu class="dropdown-login clone-dropdown">
                  <a href="#" @click="cloneEvent(singleEvent)"
                    >Clone this Event</a
                  >
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
          <div class="event-img">
            <img v-if="singleEvent.EventLogo" :src="singleEvent.EventLogo" />
            <img
              v-else
              src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2F960X192_white.jpg?alt=media"
            />
          </div>
          <div
            v-if="UserRole == 2"
            class="flex justify-between text-center event-options"
          >
            <span class="admins-check" v-if="UserRole == 2">
              <p class="text-xl font-semibold">
                <button
                  @click="
                    eventAdmins(
                      singleEvent.EventId,
                      singleEvent.EventCollectionName,
                      singleEvent.EventFullName,
                      singleEvent.EventEndDate
                    )
                  "
                >
                  <img src="../../assets/images/add-user.svg" />
                </button>
              </p>
              <small class="text-grey">Admins</small>
            </span>
            <span class="event-edit-butn">
              <p>
                <vs-button
                  color="rgb(76, 139, 246)"
                  type="filled"
                  size="small"
                  key="aaa"
                  v-on:click="editEvent(singleEvent)"
                  >Manage</vs-button
                >
              </p>
              <small class="text-grey">Select Event</small>
            </span>
            <span class="auth-check" v-if="UserRole == 2">
              <vs-switch
                v-model="singleEvent.IsPublished"
                v-on:click="beforeUnPublishConfirmation(singleEvent)"
              >
                <span slot="true">True</span>
                <span slot="false">False</span>
              </vs-switch>
              <small class="text-grey">{{
                singleEvent.IsPublished ? "Published" : "Under-Review"
              }}</small>
            </span>
          </div>
          <div
            v-if="UserRole == 3 || (UserRole == 4 && UserRole != 2)"
            class="flex justify-between text-center event-options event-manage"
          >
            <span class="admins-check" v-if="UserRole == 2">
              <p class="text-xl font-semibold">
                <button
                  @click="
                    eventAdmins(
                      singleEvent.EventId,
                      singleEvent.EventCollectionName,
                      singleEvent.EventFullName,
                      singleEvent.EventEndDate
                    )
                  "
                >
                  <img src="../../assets/images/add-user.svg" />
                </button>
              </p>
              <small class="text-grey">Admins</small>
            </span>
            <span class="event-edit-butn">
              <p>
                <vs-button
                  color="rgb(76, 139, 246)"
                  type="filled"
                  size="small"
                  key="aaa"
                  v-on:click="editEvent(singleEvent)"
                  >Manage</vs-button
                >
              </p>
              <small class="text-grey">Select Event</small>
            </span>
            <span class="auth-check" v-if="UserRole == 2">
              <vs-switch
                v-model="singleEvent.IsPublished"
                v-on:click="beforeUnPublishConfirmation(singleEvent)"
              >
                <span slot="true">True</span>
                <span slot="false">False</span>
              </vs-switch>
              <small class="text-grey">{{
                singleEvent.IsPublished ? "Published" : "Under-Review"
              }}</small>
            </span>
          </div>
        </vx-card>

        <vx-card class="single-event-wrap" style="height: 100%" v-else>
          <div class="event-img">
            <img v-if="singleEvent.EventLogo" :src="singleEvent.EventLogo" />
            <img
              v-else
              src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2F960X192_white.jpg?alt=media"
            />
          </div>
          <div class="all-event-list-right">
            <div class="all-event-list-right-top">
              <div class="event-list-details">
                <vx-tooltip :text="singleEvent.EventFullName" position="left">
                  <h4>{{ singleEvent.EventFullName }}</h4>
                </vx-tooltip>
                
                <div class="event-schedule-time">
                  <p class="text-grey date m-0">
                    {{ singleEvent.EventStartDateStr }} -
                    {{ singleEvent.EventEndDateStr }} {{ singleEvent.TimeZone }}
                  </p>
                </div>
              </div>
              <!--<a href="#">Clone</a>-->
              <!--<h4>Global Expo 2020</h4>-->
              <div class="flex items-center event-manage-buttons justify-end" style="100%">
                <div class="all-event-list-functions">
                <div
                  v-if="UserRole == 2"
                  class="flex justify-between text-center event-options"
                >
                  <span v-if="UserRole == 2" class="mr-2 admins-check">
                    <p class="text-xl font-semibold">
                      <button
                        @click="
                          eventAdmins(
                            singleEvent.EventId,
                            singleEvent.EventCollectionName,
                            singleEvent.EventFullName,
                            singleEvent.EventEndDate
                          )
                        "
                      >
                        <img src="../../assets/images/add-user.svg" />
                      </button>
                    </p>
                    <small class="text-grey">Admins</small>
                  </span>
                  <span class="event-edit-butn mr-2">
                    <p>
                      <vs-button
                        color="rgb(76, 139, 246)"
                        type="filled"
                        size="small"
                        key="aaa"
                        v-on:click="editEvent(singleEvent)"
                        >Manage</vs-button
                      >
                    </p>
                    <small class="text-grey">Select Event</small>
                  </span>
                  <span class="auth-check" v-if="UserRole == 2">
                    <vs-switch
                      v-model="singleEvent.IsPublished"
                      v-on:click="beforeUnPublishConfirmation(singleEvent)"
                    >
                      <span slot="true">True</span>
                      <span slot="false">False</span>
                    </vs-switch>
                    <small class="text-grey">{{
                      singleEvent.IsPublished ? "Published" : "Under-Review"
                    }}</small>
                  </span>
                </div>
                <div
                  v-if="UserRole == 3 || (UserRole == 4 && UserRole != 2)"
                  class="flex justify-between text-center event-options event-manage"
                >
                  <span v-if="UserRole == 2" class="mr-2 admins-check">
                    <p class="text-xl font-semibold">
                      <button
                        @click="
                          eventAdmins(
                            singleEvent.EventId,
                            singleEvent.EventCollectionName,
                            singleEvent.EventFullName,
                            singleEvent.EventEndDate
                          )
                        "
                      >
                        <img src="../../assets/images/add-user.svg" />
                      </button>
                    </p>
                    <small class="text-grey">Admins</small>
                  </span>
                  <span class="event-edit-butn mr-2">
                    <p>
                      <vs-button
                        color="rgb(76, 139, 246)"
                        type="filled"
                        size="small"
                        key="aaa"
                        v-on:click="editEvent(singleEvent)"
                        >Manage</vs-button
                      >
                    </p>
                    <small class="text-grey">Select Event</small>
                  </span>
                  <span class="auth-check" v-if="UserRole == 2">
                    <vs-switch
                      v-model="singleEvent.IsPublished"
                      v-on:click="beforeUnPublishConfirmation(singleEvent)"
                    >
                      <span slot="true">True</span>
                      <span slot="false">False</span>
                    </vs-switch>
                    <small class="text-grey">{{
                      singleEvent.IsPublished ? "Published" : "Under-Review"
                    }}</small>
                  </span>
                </div>
                </div>
                <div class="event-clone-drop">
                  <vs-dropdown vs-custom-content vs-trigger-click>
                    <a class="" href.prevent>
                      <span></span>
                      <span></span>
                      <span></span>
                    </a>

                    <vs-dropdown-menu class="dropdown-login clone-dropdown">
                      <a href="#" @click="cloneEvent(singleEvent)"
                        >Clone this Event</a
                      >
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <!-- </div> -->
    </div>

    <vs-popup
      class="holamundo publish-event"
      title="   "
      :active.sync="publishAllEventSuccess"
    >
      <div class="vx-row mb-5 success-confetti">
        <div class="text-center w-full success-class">
          <span><img src="../../assets/images/check-success.svg" /></span>
          <h2>Event has been</h2>
          <h2 class="mb-3">published successfully!</h2>
          <h5 v-if="!disablePreviewBtn">Click below for admin preview</h5>
        </div>

        <div class="text-center w-full" v-if="!disablePreviewBtn">
          <a @click="resetModal" class="preview-btn-all-event" target="_blank" :href="previewUrl"
            >Preview Now</a
          >
        </div>
      </div>
    </vs-popup>

    <vs-popup
      classContent="popup-example"
      class="holamundo"
      title="Admin List"
      :active.sync="popupActive"
    >
      <div
        class="vx-col flex justify-content-between align-items-center w-full text-left mb-5 event-admin-popup-header"
      >
        <h4>{{ eventadmindata.EventFullName }}</h4>
        <vs-button
          color="success"
          type="gradient"
          @click="addUser()"
          v-if="checkEventExipryDate(eventadmindata.EventEndDate)"
          >Add New</vs-button
        >
      </div>
      <!--items-center-->
      <div class="flex flex-wrap" style="min-height: 400px">
        <div class="flex-grow">
          <div>
            <vs-table :data="admins">
              <template slot="thead">
                <vs-th>Email</vs-th>
                <vs-th>First Name</vs-th>
                <vs-th>Last Name</vs-th>
                <vs-th>Organization</vs-th>
                <vs-th>Type</vs-th>
                <vs-th>Action</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].Email">{{
                    data[indextr].Email
                  }}</vs-td>

                  <vs-td :data="data[indextr].FirstName">{{
                    data[indextr].FirstName
                  }}</vs-td>
                  <vs-td :data="data[indextr].LastName">{{
                    data[indextr].LastName
                  }}</vs-td>
                  <vs-td :data="data[indextr].Company">{{
                    data[indextr].Company
                  }}</vs-td>
                  <!-- <vs-td :data="data[indextr].UserRoles[0].RoleName" v-if="data[indextr].UserRoles[0].RoleName == 'AnalyticsAdmin'">Analytics Admin</vs-td> -->
                  <vs-td>{{ getRole(data[indextr].UserRoles) }}</vs-td>
                  <vs-td :data="data[indextr].UserId">
                    <feather-icon
                      icon="Edit3Icon"
                      title="Edit Admin"
                      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                      @click="
                        editEventAdmin(
                          data[indextr].EventId,
                          data[indextr].UserId
                        )
                      "
                    />
                    <!--<feather-icon
                      icon="SendIcon"
                      :svgClasses="['h-6 w-6 cursor-pointer']"
                      @click="reSendMail(data[indextr].EventId,data[indextr].UserId)"
                    ></feather-icon>-->
                    <feather-icon
                      icon="SendIcon"
                      title="Re-Send Mail"
                      :svgClasses="['h-6 w-6 mr-4 cursor-pointer']"
                      @click="confirmMailReSend(data[indextr].UserId)"
                    ></feather-icon>
                    <feather-icon
                      icon="TrashIcon"
                      title="Delete Admin"
                      :svgClasses="['h-6 w-6 mr-4 cursor-pointer']"
                      v-if="checkEventExipryDate(eventadmindata.EventEndDate)"
                      @click="
                        confirmDeleteAdmin(
                          data[indextr].EventId,
                          data[indextr].UserId,
                          data[indextr].UserRoles
                        )
                      "
                    ></feather-icon>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>

          <vs-popup
            class="pop-up-wrap ppop-up-confirm"
            title="Confirm Re-Send"
            :active.sync="popupMailConfirmActive"
          >
            <div class="mt-10 mb-10 text-center">
              <h5>Do you want to re-send Invitation mail?</h5>
            </div>
            <div class="popup-button-wrap">
              <vs-button
                type="border"
                color="danger"
                v-on:click="cancelReSendMail()"
                >Cancel</vs-button
              >
              <vs-button class="mr-6" v-on:click="reSendMail()">Send</vs-button>
            </div>
          </vs-popup>
        </div>
      </div>
    </vs-popup>

    <vs-popup
      class="holamundo pop-up-wrap create-event-popup"
      title="Create New Event"
      :active.sync="popupActiveEvnetAdd"
      button-close-hidden="true"
    >
      <event-add
        @closeEventAddPopup="popupActiveEvnetAdd = false"
        @fetchEvents="getClientEvents"
      />
    </vs-popup>
    <vs-popup
      class="holamundo pop-up-wrap"
      title="Clone Event"
      button-close-hidden="true"
      :active.sync="popupCloneEvent"
      v-if="cloneEventDetail"
    >
      <event-clone :data="cloneEventDetail" @closePopup="closeClonePopup" />
    </vs-popup>
  </div>
</template>

<script>
import navMenuItems from "@/layouts/components/vertical-nav-menu/navMenuItems.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { videoPlayer } from "vue-video-player";
import VxTimeline from "@/components/timeline/VxTimeline.vue";
import "video.js/dist/video-js.css";
//import mutations from "../../mutations.js";
//import state from "@/store/state";
import moment from "moment-timezone";
import store from "@/store/store.js";
import firebase from "firebase";
import con from "@/firebase/firebaseInit.ts";
import ls from "@/common/localStorage";
import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";
import moduleClientManagement from "@/store/client-management/moduleClientManagement.js";
import moduleUserManagement from "@/store/user-management/moduleUserManagement.js";
import eventAdminAdd from "./EventAdminAdd.vue";
import eventClone from "./EventClone.vue";
import eventAdd from "./EventAddV2.vue";
import Swal from "sweetalert2";

var vm;
export default {
  components: {
    VuePerfectScrollbar,
    videoPlayer,
    VxTimeline,
    eventAdminAdd,
    eventAdd,
    eventClone,
    //store
  },
  data() {
    return {
      // card 1
      card_5: { eventname: "GlobalExpo2020", Date: "20 June, 2020" },
      admins: [],
      name: "",
      email: "",
      msg: "",
      eventadmindata: {},
      addNewDataSidebar: false,
      playerOptions: {},
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      activeConfirm: false,
      popupMailConfirmActive: false,
      popupActive: false,
      popupActiveEvnetAdd: false,
      cloneEventDetail: null,
      popupCloneEvent: false,
      radios1: true,
      eventListData: [],
      navMenuItems: [],
      UserRole: 0,
      disableAddEventBtn: true,
      switchView: false,
      showNoMappedEventMsg: false,
      publishAllEventSuccess: false,
      previewUrl: null,
      disablePreviewBtn: false,
      previewUrl: null,
    };
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  beforemount() {},
  mounted() {
    vm = this;
    //debugger;
    //const scroll_el = this.$refs.chatLogPS.$el || this.$refs.chatLogPS;
    //scroll_el.scrollTop = this.$refs.chatLog.scrollHeight;
    vm.getClientEvents();
    ls.removeSessionValueByKey("Session_Event_Id");
    ls.removeSessionValueByKey("Session_Event_CollectionName");
    ls.removeSessionValueByKey("Session_Event_FullName");
    ls.removeSessionValueByKey("Sesion_StreamingClient");
    navMenuItems.cn = null;
    this.navMenuItems = navMenuItems.getMenus();
    this.$root.$emit("updatenavMenuItems", this.navMenuItems);
    this.$root.$emit("Set_header_Session_Event_FullName");

    if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }

    this.UserRole = ls.getSessionValueByKey("Role");

    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule("userManagement", moduleUserManagement);
      moduleUserManagement.isRegistered = true;
    }
    this.fetchClientPlanDetails();
  },
  methods: {
       resetModal(){
      this.publishAllEventSuccess = false;
    },
    checkEventExipryDate(EventEndDate) {
      /*let date = new Date();
      date.setDate(date.getDate() - 30);
      if (EventEndDate && EventEndDate.seconds * 1000 >= date.getTime())
        return true;
      else return false;*/
      return true;
    },
    switchEventView(view) {
      if (view == "grid") {
        var element2 = document.getElementById("listview");
        element2.classList.add("active");
        var element = document.getElementById("gridview");
        element.classList.remove("active");
        this.switchView = false;
      } else {
        var element2 = document.getElementById("gridview");
        element2.classList.add("active");
        var element = document.getElementById("listview");
        element.classList.remove("active");
        this.switchView = true;
      }
    },
    setEventStatus: function (
      EventId,
      EventCollectionName,
      IsPublished,
      EventEndDate
    ) {
      vm.$vs.loading();
      var clientId = ls.getSessionValueByKey("Session_Client_Id");
      con.instanceDB
        .doc("ClientList")
        .collection("Clients")
        .doc(clientId)
        .collection("Events")
        .doc(EventId)
        .update({ IsPublished: IsPublished })
        .then(function () {
          con.eventDB
            .collection(EventCollectionName)
            .doc("EventInfo")
            .update({ IsPublished: IsPublished })
            .then(function () {
              if (IsPublished == true) {
                var seconds = EventEndDate * 1000;
                console.log("seconds>>>>>", seconds);
                console.log("date>>>>>", new Date().getTime());
                if (seconds >= new Date().getTime()) {
                  let Session_Client_Id = ls.getSessionValueByKey(
                    "Session_Client_Id"
                  );
                  let CustomDomain = ls.getSessionValueByKey("CustomDomain");
                  let Session_Event_Id = EventId;
                  vm.previewUrl = `https://${CustomDomain}/joincms/${Session_Client_Id}/${Session_Event_Id}/preview`;
                  vm.disablePreviewBtn = false;
                } else {
                  vm.disablePreviewBtn = true;
                }
                vm.publishAllEventSuccess = true;
              } else {
                vm.$vs.notify({
                  color: "success",
                  position: "top-center",
                  //title: "Round Table",
                  text: IsPublished
                    ? "Published Successfully"
                    : "Under-Reviewed Successfully",
                });
              }

              vm.$vs.loading.close();
            });
        });
    },
    closeClonePopup() {
      this.cloneEventDetail = null;
      vm.popupCloneEvent = false;
    },
    cloneEvent: function (eventDetail) {
      eventDetail.EventStartDate = new Date(
        eventDetail.EventStartDate.seconds * 1000
      ).toUTCString();
      eventDetail.EventEndDate = new Date(
        eventDetail.EventEndDate.seconds * 1000
      ).toUTCString();
      eventDetail.StartDate = null;
      eventDetail.EndDate = null;
      this.cloneEventDetail = eventDetail;
      vm.popupCloneEvent = true;
    },
    eventAdmins: function (
      eventId,
      eventCollectionName,
      EventFullName,
      EventEndDate
    ) {
      vm.toggleDataSidebar(false);
      vm.popupActive = true;
      vm.$vs.loading();
      vm.$store
        .dispatch("eventManagement/fetchEventAdmins", eventId)
        .then((res) => {
          vm.admins = res;
          debugger;
          vm.eventadmindata = {
            EventId: eventId,
            EventCollectionName: eventCollectionName,
            EventFullName: EventFullName,
            EventEndDate: EventEndDate,
            EventAdminId: null,
            FirstName: null,
            LastName: null,
            Company: null,
            Email: null,
            Password: null,
          };
          vm.$vs.loading.close();
        });
    },
    editEventAdmin: function (EventId, EventAdminId) {
      vm.popupActive = false;
      vm.$vs.loading();
      vm.$store
        .dispatch("eventManagement/fetchEventAdmin", {
          EventId: EventId,
          EventAdminId: EventAdminId,
        })
        .then((res) => {
          vm.eventadmindata = {
            EventId: EventId,
            EventCollectionName: null,
            EventFullName: null,
            EventAdminId: res.UserId,
            FirstName: res.FirstName,
            LastName: res.LastName,
            Company: res.Company ? res.Company : null,
            Email: res.Email,
            Password: res.Password,
            adminType: this.getRole(res.UserRoles),
          };
          vm.$vs.loading.close();
          vm.toggleDataSidebar(true);
        });
    },
    confirmDeleteAdmin: function (EventId, EventAdminId, Roles) {
      let RoleName = "";
      Roles.map((row) => {
        if (row.RoleID == 3 || row.RoleID == 4) RoleName = row.RoleName;
      });

      if (confirm("Are you sure want to remove!")) {
        vm.popupActive = false;
        vm.$vs.loading();
        vm.$store
          .dispatch("eventManagement/deleteEventAdmin", {
            EventId: EventId,
            UserId: EventAdminId,
            RoleName: RoleName,
          })
          .then((res) => {
            vm.$vs.notify({
              position: "top-center",
              color: "success",
              title: "Event Admin",
              text: "Removed successfully.",
            });
            vm.$vs.loading.close();
          });
      }
    },
    confirmMailReSend(EventAdminId) {
      //this.activeConfirm = true;
      debugger;
      vm.popupMailConfirmActive = true;
      vm.eventadmindata.EventAdminId = EventAdminId;
      //this.$vs.dialog({
      //  type: "confirm",
      //  color: "danger",
      //  title: `Confirm Re-Send`,
      //  acceptText: "Yes",
      //  cancelText: "No",
      //  text: "Do you want to Re-Send Invitation mail?",
      //  accept: this.acceptAlert,
      //});
    },
    acceptAlert(color) {
      alert("acceptAlert");
      vm.$vs.notify({
        color: "danger",
        title: "Deleted image",
        text: "The selected image was successfully deleted",
      });
      vm.reSendMail(vm.eventadmindata.EventId, vm.eventadmindata.EventAdminId);
    },
    reSendMail: function (EventId, EventAdminId) {
      //this.popupActive = false;
      vm.$vs.loading();
      debugger;
      vm.$store
        .dispatch("eventManagement/sendMail", {
          EventId: vm.eventadmindata.EventId,
          EventAdminId: vm.eventadmindata.EventAdminId,
          EventCollectionName: vm.eventadmindata.EventCollectionName,
        })
        .then((res) => {
          vm.$vs.loading.close();
          vm.$vs.notify({
            color: "success",
            title: "Invitation",
            text: "Mail sent successfully.",
          });
        });
    },
    cancelReSendMail() {
      vm.popupMailConfirmActive = false;
    },
    addUser: function () {
      /*localStorage.setItem("Session_Event_Id", eventId);
      localStorage.setItem("Session_Event_CollectionName", eventCollectionName);
      localStorage.setItem("Session_Event_FullName", EventFullName);
      location.href =  "/event/attendees"*/
      /*let info = {
        Session_Event_Id: eventId,
        Session_Event_CollectionName: eventCollectionName,
        Session_Event_FullName: EventFullName
      };
      ls.setSessionUserInfo(info);
      navMenuItems.cn = ls.getSessionEventCollectionName();
      this.navMenuItems = navMenuItems.getMenus();
      this.$root.$emit("updatenavMenuItems", this.navMenuItems);
      this.$root.$emit(
        "Set_header_Session_Event_FullName",
        ls.getSessionValueByKey("Session_Event_FullName")
      );*/
      /*this.eventadmindata = {
        EventId: eventId,
        EventCollectionName: eventCollectionName,
        EventFullName: EventFullName,
        EventAdminId: null,
        FirstName: null,
        LastName: null,
        Email: null,
        Password: null
      }*/
      this.popupActive = false;
      this.toggleDataSidebar(true);
      //this.$router.push({ name: "attendees" });
      //location.href =  "/event/attendees"
    },
    addEvent: function () {
      //this.store.commit(("sessionEventId", ""));
      ls.removeSessionValueByKey("Session_Event_Id");
      ls.removeSessionValueByKey("Session_Event_CollectionName");
      ls.removeSessionValueByKey("Session_Event_FullName");
      //location.href = "/event/add";
      //this.$router.push("/event/addv2");
      this.popupActiveEvnetAdd = true;
    },
    closeEventAddPopup: function () {
      this.popupActiveEvnetAdd = false;
    },
    editEvent: function (obj) {
      this.popupActive = false;

      var startDate = obj.EventStartDate
        ? moment
            .tz(
              new Date(obj.EventStartDate.seconds * 1000).toUTCString(),
              obj.TimeZone
            )
            .format("MM/DD/YYYY HH:mm")
        : null;
      var endDate = obj.EventEndDate
        ? moment
            .tz(
              new Date(obj.EventEndDate.seconds * 1000).toUTCString(),
              obj.TimeZone
            )
            .format("MM/DD/YYYY HH:mm")
        : null;
      let info = {
        Session_Event_Id: obj.EventId,
        Session_Event_CollectionName: obj.EventCollectionName,
        Session_Event_FullName: obj.EventFullName,
        Session_Event_TZ: obj.TimeZone,
        Session_EventStartDate: startDate,
        Session_EventEndDate: endDate,
        Sesion_StreamingClient: obj.StreamingClient,
        Sesion_EventAccessType: obj.EventAccessType,
        Default_Event_Language: obj.DefaultLanguage,
        Session_LocationType: obj.LocationType.Name,
      };
      ls.setSessionUserInfo(info);
      if (ls.getSessionValueByKey("Role") == 4)
        location.href = "/event/dashboard";
      else location.href = "/event/overview";
      //this.$router.push({ name: "event-edit" });
      /*this.$store
        .dispatch("eventManagement/reInitEventSession")
        .then(res => {
          this.$router.push({ name: "event-edit" });
        })
        .catch(err => {
          alert("Something went wrong!");
        });*/
    },
    getClientEvents: function () {
      this.$vs.loading();
      this.getUserEvents();
      var clientId = ls.getSessionValueByKey("Session_Client_Id");
      con.instanceDB
        .doc("ClientList")
        .collection("Clients")
        .doc(clientId)
        .collection("Events")
        .orderBy("ModifiedTime", "desc")
        .get()
        .then((querySnapshot) => {
          this.$vs.loading.close();
          vm.eventListData = [];
          //debugger;
          querySnapshot.forEach((doc) => {
            var data = doc.data();

            debugger;
            if (ls.getSessionValueByKey("Role") == 2) {
              data.EventStartDateStr = data.EventStartDate
                ? vm.SetTimeByZone(
                    new Date(data.EventStartDate.seconds * 1000).toUTCString(),
                    data.TimeZone
                  )
                : null;
              data.EventEndDateStr = data.EventEndDate
                ? vm.SetTimeByZone(
                    new Date(data.EventEndDate.seconds * 1000).toUTCString(),
                    data.TimeZone
                  )
                : null;
              vm.eventListData.push(data);
              vm.showNoMappedEventMsg =
                vm.eventListData.length == 0 ? true : false;
            }
            if (ls.getSessionValueByKey("Role") == 3) {
              con.instanceDB
                .doc("ClientList")
                .collection("Clients")
                .doc(clientId)
                .collection("UserEvents")
                .where("AdminEventIDs", "array-contains", data.EventId)
                .get()
                .then(function (querySnapshot) {
                  querySnapshot.docs.forEach((usereventsdoc) => {
                    if (
                      usereventsdoc.data().UserId ==
                      ls.getSessionValueByKey("UserId")
                    ) {
                      /*data.EventStartDateStr = vm.getFormattedDate(
                        data.EventStartDate.seconds
                      );
                      data.EventEndDateStr = vm.getFormattedDate(
                        data.EventEndDate.seconds
                      );*/
                      data.EventStartDateStr = data.EventStartDate
                        ? vm.SetTimeByZone(
                            new Date(
                              data.EventStartDate.seconds * 1000
                            ).toUTCString(),
                            data.TimeZone
                          )
                        : null;
                      data.EventEndDateStr = data.EventEndDate
                        ? vm.SetTimeByZone(
                            new Date(
                              data.EventEndDate.seconds * 1000
                            ).toUTCString(),
                            data.TimeZone
                          )
                        : null;
                      vm.eventListData.push(data);
                    }
                  });
                  vm.showNoMappedEventMsg =
                    vm.eventListData.length == 0 ? true : false;
                });
            } else if (ls.getSessionValueByKey("Role") == 4) {
              con.instanceDB
                .doc("ClientList")
                .collection("Clients")
                .doc(clientId)
                .collection("UserEvents")
                .where("AnalyticsAdminEventIDs", "array-contains", data.EventId)
                .get()
                .then(function (querySnapshot) {
                  querySnapshot.docs.forEach((usereventsdoc) => {
                    if (
                      usereventsdoc.data().UserId ==
                      ls.getSessionValueByKey("UserId")
                    ) {
                      data.EventStartDateStr = data.EventStartDate
                        ? vm.SetTimeByZone(
                            new Date(
                              data.EventStartDate.seconds * 1000
                            ).toUTCString(),
                            data.TimeZone
                          )
                        : null;
                      data.EventEndDateStr = data.EventEndDate
                        ? vm.SetTimeByZone(
                            new Date(
                              data.EventEndDate.seconds * 1000
                            ).toUTCString(),
                            data.TimeZone
                          )
                        : null;
                      vm.eventListData.push(data);
                    }
                  });
                  vm.showNoMappedEventMsg =
                    vm.eventListData.length == 0 ? true : false;
                });
            }
          });
        });
    },
    addMenu() {
      let inserMenu = [
        {
          DisplayLabel: "Location Map",
          DisplayLabel_de: "Location Map",
          DisplayLabel_fr: "Location Map",
          DisplayLabel_zh: "Location Map",
          DisplayOrder:32,
          FeatureID:18,
          FeatureName:"Floormap",
          GroupID:0,
          IconUrl:"https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fmenuicons%2Flight%2Fhome.png?alt=media",
          IsEditable:true,
          IsOptional:true,
          IsPublished:true,
          MenuID:1032,
          Name:"Location Map",
          PageUrl:"/locationmap",
          PositionInPage:1,
          PositionIsEditable:true
        }
      ]

      con.instanceDB.doc("Menu").get().then(function(doc){
        let Allmenu = doc.data().AllMenu
        let menuArray = Allmenu.concat(inserMenu) 
        //console.log(menuArray)
        con.instanceDB.doc("Menu").update({
          AllMenu: menuArray,
        }).then(function(){
          alert('Menu Add Done!')
        })
      })
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment.tz(strDateTime, timeZone).format("MMM DD, YYYY");
      return date;
    },
    getFormattedTime: function (seconds) {
      var dt = new Date(seconds * 1000);
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      var amPM = hours < 12 || hours == 0 ? "AM" : "PM";
      hours = hours > 12 ? hours - 12 : hours;
      hours = hours == 0 ? 12 : hours;
      minutes = minutes == 0 ? "00" : minutes;
      var formattedValue =
        hours.toString() + ":" + minutes.toString() + " " + amPM;
      return formattedValue;
    },
    getFormattedDate: function (seconds) {
      var dt = new Date(seconds * 1000);
      var day = dt.getDate();
      var month = dt.getMonth();
      var year = dt.getFullYear();
      var hourmin = this.getFormattedTime(seconds);
      //const monthNames = [
      //  "January",
      //  "February",
      //  "March",
      //  "April",
      //  "May",
      //  "June",
      //  "July",
      //  "August",
      //  "September",
      //  "October",
      //  "November",
      //  "December"
      //];
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      //var formattedValue =
      //  monthNames[month] + " " + day.toString() + ", " + year + " " + hourmin;
      var formattedValue =
        monthNames[month] + " " + day.toString() + ", " + year; // + " " + hourmin;
      return formattedValue;
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    fetchClientPlanDetails: function () {
      var clientId = ls.getSessionValueByKey("Session_Client_Id");
      this.$store
        .dispatch("clientManagement/fetchClient", clientId)
        .then((res) => {
          if (res.data.EventCount <= this.eventListData.length) {
            this.disableAddEventBtn = true;
          } else {
            this.disableAddEventBtn = false;
          }
        });
    },

    beforeUnPublishConfirmation: function (data) {
      vm = this;
      if (data.IsPublished == true) {
        const { value: text } = Swal.fire({
          title: "Do you want to Unpublish the event?",
          input: "text",
          inputPlaceholder: "Type 'unpublish' and hit the Submit button",
          showCancelButton: true,
          confirmButtonText: "Submit",
          inputValidator: (value) => {
            if (value.toLocaleLowerCase().trim() == "unpublish") {
              this.setEventStatus(
                data.EventId,
                data.EventCollectionName,
                false,
                data.EventEndDate.seconds
              );
            } else {
              return "Try again! Please type 'unpublish' and hit Submit.";
            }
          },
        }).then(function (result) {
          if (result.dismiss != null) {
            vm.getClientEvents();
          }
        });
      } else {
        this.setEventStatus(
          data.EventId,
          data.EventCollectionName,
          true,
          data.EventEndDate.seconds
        );
      }
    },
    getRole(RoleArr) {
      let RoleName = "";
      RoleArr.filter((row) => {
        if (row.RoleID != 10) RoleName = row.RoleName;
      });
      return RoleName;
    },
    getUserEvents() {
      this.$store.dispatch("eventManagement/getUserEvents").then((res) => {});
    },
  },
  created() {
    // Card 5
    /*this.$http
      .get("/api/users/58")
      .then(response => {
        this.card_5 = response.data;
      })
      .catch(error => {
        console.log(error);
      });*/
  },
};
</script>


<style lang="scss">
#demo-basic-card {
  .overlay-card {
    .vx-card__collapsible-content {
      max-height: 485px;
    }
  }

  .chat-card-log {
    height: 360px;

    .chat-sent-msg {
      background-color: #f2f4f7 !important;
    }
  }

  .card-video {
    .video-js {
      height: 370px;
    }
  }
}
.preview-btn-all-event {
  display: inline-block;
  border: 1px solid #4c8bf6;
  border-radius: 5px;
  padding: 8px 15px;
  background: rgb(76, 139, 246);
  color: #fff !important;
  font-size: 14px;
  cursor: pointer;
  font-weight: 600;
}
</style>